import React, { useState, useEffect } from 'react';
import {
  Box,
  CssBaseline,
  Container,
  Card,
  CardContent,
  Button,
  Grid,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  IconButton
} from "@mui/material";
import AuthApi4 from "../services/authApi";
import Navbar from "../sidebar/SideNavbar";
import setTopBox from "../images/stb_new.jpeg";
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ClearIcon from '@mui/icons-material/Clear';

export default function BulkRenewal() {
  const [stbData, setStbData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [checkedItems, setCheckedItems] = useState({});
  const [selectedSTBs, setSelectedSTBs] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    stbinfoNew();
  }, []);

  const stbinfoNew = async () => {
    setLoading(true);
    let data = {
      records: [
        {
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID: localStorage.getItem("payment_cust_num"),
          type: "bulkSubMngmnt"
        },
      ],
    };

    try {
      const response = await AuthApi4.stbinfo(data);
      setStbData(response.data.stbdetails || []);
      setLoading(false);

      const initialCheckedState = {};
      (response.data.stbdetails || []).forEach((item, index) => {
        initialCheckedState[index] = false;
      });
      setCheckedItems(initialCheckedState);
    } catch (e) {
      setLoading(false);
      console.log("STB INFO Error", e);
    }
  };

  const handleCheckboxChange = (index, stbId) => {
    setCheckedItems(prev => ({
      ...prev,
      [index]: !prev[index]
    }));

    setSelectedSTBs(prev => {
      if (prev.includes(stbId)) {
        return prev.filter(id => id !== stbId);
      } else {
        return [...prev, stbId];
      }
    });
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (option) => {
    setAnchorEl(null);
    if (!option || selectedSTBs.length === 0) return;

    const stbIdsArray = selectedSTBs.map(item => ({ stb_id: item }));
    const selectedSTBData = stbData.filter(item => selectedSTBs.includes(item.STB_ID));
    const totalSubTotal = selectedSTBData.reduce(
      (sum, stb) => sum + parseFloat(stb.sub_total || 0),
      0
    );

    if (option === "Renew") {
      try {
        const data1 = { records: [{ CUST_ID: localStorage.getItem("payment_cust_num"), type: "wallet" }] };
        const response = await AuthApi4.stbinfo(data1);
        const walletAmount = parseFloat(response.data.stbdetails[0].bill_total);

       if (walletAmount < totalSubTotal) {
  Swal.fire({ icon: "error", title: "Insufficient Amount", text: "Insufficient Amount.." });
  return;
}

        const result = await Swal.fire({
          title: "Are you sure?",
          text: "Do you want to Renew?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          reverseButtons: true, 
        });

        if (result.isConfirmed) {
          setLoading(true);
          const renewData = {
            operator_id: parseInt(localStorage.getItem("ownerId")),
            CUST_ID: localStorage.getItem("payment_cust_num"),
            stb_ids: stbIdsArray,
            type: "renewBulk",
          };
          const renewResponse = await AuthApi4.bulkSTBRenew(renewData);
          setLoading(false);

          if (renewResponse.data[0].p_out_mssg_flg === "S") {
            Swal.fire({ icon: "success", title: "Renewed Successfully" }).then(() =>
              window.location.reload()
            );
          } else {
            Swal.fire({
              icon: "error",
              title: "Failed to Renew",
              text: renewResponse.data[0].p_out_mssg || "An error occurred while bulk renew.",
            });
          }
        }
      } catch (error) {
        setLoading(false);
        console.log("Bulk Renew Error:", error);
      }

    } else if (option === "Add channel") {
      navigate("/bulkAddChannel", { state: { stbId: stbIdsArray } });
    } else if (option === "Modify and Renew") {
      navigate("/bulkModify", { state: { stbId: stbIdsArray } });
    }
  };

  const handleRefresh = async () => {
    setLoading(true);
    let payload = {
      PHONE: localStorage.getItem("phoneNumber"),
      operator_id: parseInt(localStorage.getItem("ownerId")),
      FLAG: "A"
    };

    try {
      const response = await fetch(
        "https://api.mobiezy.in/php/NXTV2/hotel_import.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );
      await response.json();
      localStorage.setItem("BULK_IMPORTED", "Y");
      await stbinfoNew();
      Swal.fire({ icon: "success", title: "Data Refreshed", timer: 1200, showConfirmButton: false });
    } catch (error) {
      console.log("REFRESH ERROR", error);
      Swal.fire({ icon: "error", title: "Refresh Failed" });
      setLoading(false);
    }
  };

  // ---- TOGGLE SELECT ALL / UNSELECT ALL ----
  const checkedCount = Object.values(checkedItems).filter(Boolean).length;
  const totalSelectedAmount = stbData
    .filter(item => selectedSTBs.includes(item.STB_ID))
    .reduce((sum, stb) => sum + parseFloat(stb.sub_total || 0), 0);

  // ---- Filter STBs based on search ----
  const filteredStbData = stbData.filter((item) => {
  const search = searchTerm.toLowerCase();

  // Convert every item value to string and combine
  const combinedValues = Object.values(item)
    .join(" ")
    .toLowerCase();

  return combinedValues.includes(search);
});


  return (
    <div style={{ display: "flex", background: "#F5F5F5" }}>
      <CssBaseline />
      <Navbar />
      <main style={{ flexGrow: 1 }}>
        <Container sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", padding: 10 }}>
          <Box display="flex" alignItems="center" flexWrap="wrap">
            <h3 style={{ marginRight: "20px" }}>Bulk Renewal</h3>

            {/* Toggle Select All Button */}
            <Button
              variant="contained"
              color={checkedCount === stbData.length ? "warning" : "primary"}
              onClick={() => {
                if (checkedCount === stbData.length) {
                  const newChecked = {};
                  stbData.forEach((_, index) => (newChecked[index] = false));
                  setCheckedItems(newChecked);
                  setSelectedSTBs([]);
                } else {
                  const newChecked = {};
                  stbData.forEach((_, index) => (newChecked[index] = true));
                  setCheckedItems(newChecked);
                  setSelectedSTBs(stbData.map(item => item.STB_ID));
                }
              }}
            >
              {checkedCount === stbData.length ? "Unselect All" : "Select All"}
            </Button>

            <Button
              variant="contained"
              sx={{ marginLeft: "15px", backgroundColor: "#ff8c00", '&:hover': { backgroundColor: "#ffad42" } }}
              onClick={handleRefresh}
            >
              Refresh
            </Button>

            {/* ---- Search Bar ---- */}
           <TextField
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
  placeholder="Search STB / VC / Customer ID..."
  size="small"
  sx={{ marginLeft: "15px", width: "350px" }}
  InputProps={{
    endAdornment: (
      <InputAdornment position="end">
        {searchTerm && (
          <IconButton onClick={() => setSearchTerm("")} size="small">
            <ClearIcon fontSize="small" />
          </IconButton>
        )}
      </InputAdornment>
    ),
  }}
/>

            <div style={{ marginLeft: "auto", textAlign: "right", paddingRight: "10px", lineHeight: "1.9" }}>
              <h5 style={{ margin: 0 }}>Selected Boxes: {checkedCount}</h5>
              <h5 style={{ margin: 0 }}>Total Pack Amount: ₹ {totalSelectedAmount.toFixed(2)}</h5>
            </div>
          </Box>

          <Grid container spacing={1} style={{ marginTop: "10px" }}>
            {loading ? (
              <Box sx={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "20px" }}>
                <CircularProgress />
              </Box>
            ) : Array.isArray(filteredStbData) && filteredStbData.length > 0 ? (
              filteredStbData.map((item, index) => (
                <Grid item xs={12} md={4} key={index}>
                  <Card
                    sx={{
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      backgroundColor: checkedItems[index] ? "#d3ffd3" : "#f5f5f5",
                      borderRadius: 4,
                      boxShadow: 6,
                    }}
                  >
                    <Grid container style={{ width: "100%", position: "relative" }}>
                      <Grid item xs={12} style={{ display: "flex", alignItems: "center", padding: "10px" }}>
                        <p style={{ fontSize: "1rem", margin: 0 }}>
                          <strong>ID: </strong>
                          <strong style={{ color: "#ff8c00" }}>{item.CUSTOMER_ID}</strong>
                        </p>
                      </Grid>
                      <div style={{ position: "absolute", right: "2px", top: "2px" }}>
                        <FormControlLabel
                          control={<Checkbox checked={checkedItems[index] || false} onChange={() => handleCheckboxChange(index, item.STB_ID)} />}
                        />
                      </div>
                    </Grid>

                    <Grid container>
                      <Grid item xs={5} style={{ padding: "6px" }}>
                        <img src={setTopBox} alt="Set-Top Box" style={{ width: "85%", maxHeight: "100px", objectFit: "contain" }} />
                      </Grid>
                      <Grid item xs={7}>
                        <CardContent style={{ padding: "5px" }}>
                          <p style={{ fontSize: "0.7rem" }}>STB Number: <strong>{item.STB_NUMBER}</strong></p>
                          <p style={{ fontSize: "0.7rem" }}>VC Number: <strong>{item.VC_NUMBER}</strong></p>
                          <p style={{ fontSize: "0.7rem" }}>Pack Amount: <strong>{item.sub_total}</strong></p>
                          <p style={{ fontSize: "0.7rem" }}>Status: <strong style={{ color: item.STATUS === "Active" ? "green" : "red" }}>{item.STATUS}</strong></p>
                          <p style={{ fontSize: "0.7rem" }}>Expiry: <strong>{moment(item.PRE_END_DATE).utc().format("DD-MM-YYYY")}</strong></p>
                        </CardContent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              ))
            ) : (
              <p>No data available</p>
            )}
          </Grid>

          {/* Sticky Bottom Bar */}
          <Grid container spacing={1} sx={{ position: "sticky", bottom: 0, background: "#ffffff", padding: "10px 0", zIndex: 999, borderTop: "1px solid #ddd", marginTop: "20px" }}>
            <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
              <div style={{ position: "fixed", bottom: "90px", right: "90px", zIndex: 1000 }}>
                <button
                  onClick={handleClick}
                  disabled={selectedSTBs.length === 0}
                  style={{
                    backgroundColor: selectedSTBs.length === 0 ? "#FFD8A8" : "orange",
                    color: "white",
                    border: "none",
                    width: "70px",
                    height: "70px",
                    borderRadius: "50%",
                    fontWeight: "bold",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
                    fontSize: "12px",
                    textTransform: "uppercase",
                    opacity: selectedSTBs.length === 0 ? 0.6 : 1,
                    transition: "0.3s ease",
                  }}
                >
                  RENEW
                </button>
              </div>

              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
                <MenuItem onClick={() => handleClose("Renew")}>Renew Existing Plan</MenuItem>
                <MenuItem onClick={() => handleClose("Modify and Renew")}>Modify and Renew</MenuItem>
                <MenuItem onClick={() => handleClose("Add channel")}>Add channel</MenuItem>
              </Menu>
            </Grid>
          </Grid>
        </Container>
      </main>
    </div>
  );
}
